import {
	Component,
	OnInit,
	Input,
	ChangeDetectorRef,
	ViewChild,
	ElementRef,
	Inject,
	Optional,
} from "@angular/core";
import {
	PageSettingsModel,
	GridComponent,
	ExcelExportService,
	QueryCellInfoEventArgs,
	ToolbarItems,
	ColumnChooserService,
	VirtualScrollService,
	FilterService,
	FilterSettingsModel,
	ResizeService,
	ExcelQueryCellInfoEventArgs,
	ColumnChooserSettingsModel,
	PagerComponent,
} from "@syncfusion/ej2-angular-grids";

import { DashboardPorletsService } from "../../dashboardPorlets.service";
import { ApiList } from "../../api";
import { DashboardService } from "../../dashboard.service";
import { Subscription } from "rxjs";
import { DataUtil } from "@syncfusion/ej2-data";
import { API_SERVICE_TOKEN, PBF_TOKEN } from "../../../service/InjectionToken";

import moment from "moment";
import { getTranslation } from "../../../utils/utils";

@Component({
	selector: "rs-gadget-table",
	templateUrl: "./gadget-table.component.html",
	styleUrls: ["./gadget-table.component.scss"],
	providers: [
		ExcelExportService,
		ColumnChooserService,
		VirtualScrollService,
		FilterService,
		ResizeService,
	],
})
export class GadgetTableComponent implements OnInit {
	@Input() portlet;
	@Input() dashboard;
	@Input() portlets;
	@ViewChild("grid", { static: false }) public grid: GridComponent;
	@ViewChild("pager", { static: false }) public pager: PagerComponent;
	private config;
	public translation;
	private userInfo;
	private datePipeFormat;
	public filterSettings: FilterSettingsModel;
	public filter: Object;
	public data;
	public tableList;
	private tableList_footer = [];
	private formatSettings = [];
	private toolbarOptions: ToolbarItems[];
	public options: PageSettingsModel;
	public aggregates: object;
	private subscriptions: Subscription[] = [];
	// 已经保存过的列数据配置
	private configFields = [];
	private quarterFormat;
	private formatDates = [];
	public ColumnChooserSettings: ColumnChooserSettingsModel;
	public millionFields = [];
	// Pager
	public currentPage = 1; // 当前页数
	public pageSize = 10; // 一页显示行数
	public totalRecordsCount; // 总行数
	public filterContents; // 所有可以过滤的选项
	public sort; // 0表示降序 1表示升序
	public sortedColumn; // sort的列名
	public pageLoading;
	public currentFilterField; // 当前过滤的字段;
	public allFields;
	hideTable: boolean;
	constructor(
		public dashboardPorletsService: DashboardPorletsService,
		private api: ApiList,
		private ref: ChangeDetectorRef,
		private dashboardService: DashboardService,
		private el: ElementRef,
		@Optional() @Inject(PBF_TOKEN) private pbf: any,
		@Optional() @Inject(API_SERVICE_TOKEN) private http: any,
	) {}
	ngOnInit() {
		this.getInfo();
		this.filterSettings = { type: "Menu" };
		this.ColumnChooserSettings = { operator: "contains" };
		this.filter = { type: "CheckBox" };
		this.toolbarOptions = ["ColumnChooser"];
		this.options = { pageSize: 10, pageSizes: ["10", "50", "100"] };
		this.quarterFormat = this.setQuarterFormat();
		this.getTableData();
	}

	ngAfterViewInit(): void {
		this.subscriptions.push(
			this.dashboardService.getchangeTable().subscribe((updated) => {
				if (updated) {
					this.pageSize = 10;
					this.currentPage = 1;
					this.getTableData();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getRefreshGadget().subscribe((e) => {
				if (!e) {
					return;
				}
				const id = e["newId"];
				if (id === this.portlet.newId || id === this.portlet.id) {
					this.pageSize = 10;
					this.currentPage = 1;
					this.getTableData();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getStartRefresh().subscribe((dashboardId) => {
				if (dashboardId === this.dashboard.id) {
					this.pageLoading = true;
					this.ref.markForCheck();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getUpdated().subscribe((newId) => {
				if (newId === this.portlet.newId || newId === this.portlet.id) {
					this.pageSize = 10;
					this.currentPage = 1;
					this.getTableData();
					if (this.grid) {
						this.grid.columns.forEach((item) => {
							this.tableList.forEach((table) => {
								if (
									item.field === table.colName &&
									table.format &&
									table.format.length &&
									table.format[0].formatChecked
								) {
									item.headerText =
										table.displayName ||
										table.langValue ||
										this.translation[table.langCode] ||
										table.langCode;
									if (
										["number", "percent"].includes(
											table.dataType
										)
									) {
										let formatString;
										if (table.dataType === "number") {
											formatString =
												this.pbf.formatNumber(
													table.format[0]
														.selectedFormat
												);
										} else if (
											table.dataType === "percent"
										) {
											formatString =
												this.pbf.formatPercent(
													table.format[0]
														.selectedFormat
												);
										}
										item.format = formatString;
									}
								}
							});
						});
					}
					// this.grid.refreshColumns();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getTableFormat().subscribe((data) => {
				if (data === this.portlet.newId) {
					this.getTableData();
					this.grid.columns.forEach((item) => {
						this.tableList.forEach((table) => {
							if (
								item.field === table.colName &&
								table.format &&
								table.format.length &&
								table.format[0].formatChecked
							) {
								item.headerText =
									table.displayName ||
									table.langValue ||
									this.translation[table.langCode] ||
									table.langCode;
								if (
									["number", "percent"].includes(
										table.dataType
									)
								) {
									let formatString;
									if (table.dataType === "number") {
										formatString = this.pbf.formatNumber(
											table.format[0].selectedFormat
										);
									} else if (table.dataType === "percent") {
										formatString = this.pbf.formatPercent(
											table.format[0].selectedFormat
										);
									}
									item.format = formatString;
								}
							}
						});
					});
					this.hideTable = true;
					this.pageLoading = true;
					this.ref.markForCheck();
					setTimeout(() => {
						this.hideTable = false;
						this.pageLoading = false;
						this.ref.markForCheck();
					}, 300);
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	public customiseCell(args: QueryCellInfoEventArgs) {
		if (args.column.type === "date" || args.column.type === "dateTime") {
			const { field } = args.column;
			if (!args.data[field]) {
				args.column.type = "string";
				args.column.format = "";
			}
		}
		let queryCell =
			this.tableList &&
			this.tableList.filter(
				(item) => item.colName === args.column.field
			)[0];

		if (
			queryCell &&
			queryCell.format &&
			queryCell.format.length &&
			queryCell.format[0].formatChecked
		) {
			// SMP2-3416 0的format start
			if (
				[2, 5, 8, 11, 14, 17].includes(
					queryCell.format[0].selectedFormat
				) &&
				args.data[queryCell.colName] === 0
			)
				args.cell.innerHTML = "-";
			if (
				[3, 6, 9, 12, 15, 18].includes(
					queryCell.format[0].selectedFormat
				) &&
				args.data[queryCell.colName] === 0
			)
				args.cell.innerHTML = "";
			// SMP2-3416 0的format end
		}

		if (
			queryCell &&
			queryCell.format &&
			queryCell.format.length &&
			queryCell.format[0].fontSettingChecked
		) {
			if (
				queryCell.format[0].formatChecked &&
				queryCell.format[0].compareSelect
			) {
				let cellData = args.data[args.column.field];
				let condition: Boolean = false;
				switch (queryCell.format[0].compareSelect) {
					case "LessThan":
						condition =
							cellData <
							Number(queryCell.format[0].compareValue1);
						break;
					case "LessThanOrEqualTo":
						condition =
							cellData <=
							Number(queryCell.format[0].compareValue1);
						break;
					case "GreaterThan":
						condition =
							cellData >
							Number(queryCell.format[0].compareValue1);
						break;
					case "GreaterThanOrEqualTo":
						condition =
							cellData >=
							Number(queryCell.format[0].compareValue1);
						break;
					case "Equals":
						condition =
							cellData ===
							Number(queryCell.format[0].compareValue1);
						break;
					case "NotEquals":
						condition =
							cellData !==
							Number(queryCell.format[0].compareValue1);
						break;
					case "Between":
						condition =
							cellData >=
								Number(queryCell.format[0].compareValue1) &&
							cellData <= queryCell.format[0].compareValue2;
						break;
					case "NotBetween":
						condition =
							cellData <
								Number(queryCell.format[0].compareValue1) &&
							cellData >
								Number(queryCell.format[0].compareValue2);
						break;
					default:
						break;
				}
				if (condition) this.cellAddStyle(args, queryCell);
			} else this.cellAddStyle(args, queryCell);
		}

		// date format about quarterly
		let dateFields =
			this.formatDates &&
			this.formatDates.map((el) => {
				return el.name;
			});
		if (
			args.column.field &&
			dateFields &&
			dateFields.includes(args.column.field) &&
			queryCell.format &&
			queryCell.format.length &&
			queryCell.format[0].formatChecked
		) {
			let date = new Date(args.data[args.column.field]);
			let quarter =
				Math.floor((date.getMonth() + 1) % 3) == 0
					? Math.floor((date.getMonth() + 1) / 3)
					: Math.floor((date.getMonth() + 1) / 3) + 1;

			let format;

			this.formatDates.map((el) => {
				if (el.name == args.column.field) format = el.format;
			});
			let year: any;
			switch (format) {
				case "Q1 2021":
					year = date.getFullYear();
					args.cell.innerHTML = "Q" + quarter + " " + year;
					break;
				case "Q1 21":
					year = (date as any).getYear() - 100;
					args.cell.innerHTML = "Q" + quarter + " " + year;
					break;
				case "2021 Q1":
					year = date.getFullYear();
					args.cell.innerHTML = year + " " + "Q" + quarter;
					break;
				case "21 Q1":
					year = (date as any).getYear() - 100;
					args.cell.innerHTML = year + " " + "Q" + quarter;
					break;
			}
		}

		if (args.column.field)
			if (
				["MOIC", "DPI", "TVPI", "RVPI", "PIC", "Multiple"].includes(
					args.column.field
				)
			) {
				if (args.data && args.data[args.column.field]) {
					// 渲染过一次后，就用原数据就好了
					args.cell.innerHTML = `<div>${
						args.data[args.column.field].indexOf instanceof Function
							? args.data[args.column.field]
							: this.getXTxt(args.column.field, args.data)
					}
				</div>`;
				}
			}
		if (
			args.column &&
			args.column.format &&
			args.column.format === "dd-MMM-yyyy"
		) {
			args.cell.innerHTML = `<div>${moment(
				args.data[args.column.field]
			).format("DD-MMM-yyyy")}</div>`;
		}
	}

	private cellAddStyle(args, queryCell) {
		if (queryCell.format[0].fontSettingChecked) {
			let formatCellData = args.data[args.column.field];
			if (Math.sign(formatCellData) !== 0)
				if (Math.sign(formatCellData) === -1) {
					args.cell.style.cssText += `color: ${queryCell.format[0].negaFontColor} !important`;
					args.cell.style.cssText += `font-size: ${queryCell.format[0].negaFontSizeValue} !important`;
					args.cell.style.cssText += `font-family: ${queryCell.format[0].negaFontFamilyValue} !important`;
					args.cell.style.cssText += `background-color: ${queryCell.format[0].negaBackgroundColor} !important`;
				} else {
					args.cell.style.cssText += `color: ${queryCell.format[0].fontColor} !important`;
					args.cell.style.cssText += `font-size: ${queryCell.format[0].fontSizeValue} !important`;
					args.cell.style.cssText += `font-family: ${queryCell.format[0].fontFamilyValue} !important`;
					args.cell.style.cssText += `background-color: ${queryCell.format[0].backgroundColor} !important`;
				}
		}
	}

	private async getTableData() {
		this.pageLoading = false;
		this.config = JSON.parse(this.portlet.config);
		if (this.config.fields) {
			if (this.dashboardPorletsService.allFieldsObj[this.portlet.id]) {
				this.config.fields =
					this.dashboardPorletsService.setConfigFields(
						this.dashboardPorletsService.allFieldsObj[
							this.portlet.id
						],
						this.config.fields
					);
			}
			this.configFields = [...this.config.fields];
		}
		// ejs-grid 坑点：列头数据，colName中不能含有空格
		// GetSchema接口中获取的所有列的dataType和GetPortletDataOrCreate接口中返回的数据类型必须保持一致，否则会导致数据总量显示，但是列表中无数据
		const data = this.dashboardPorletsService.getResultByDataTable(
			this.portlet,
			false,
			false,
			this.dashboard.id
		);
		this.data = data ? DataUtil.parse.parseJson(data) : [];
		this.data = this.data.map((item) => {
			const translationMap = {
				Indirect: this.translation.INDIRECT || "Indirect",
				Direct: this.translation.DIRECT || "Direct",
			};
			return {
				...item,
				DirectIndirect:
					translationMap[item.DirectIndirect] || item.DirectIndirect,
			};
		});
		this.totalRecordsCount =
			this.dashboardPorletsService.getResultByDataTable(
				this.portlet,
				true,
				true,
				this.dashboard.id
			);

		if (
			this.config &&
			this.configFields &&
			this.configFields.length &&
			this.data &&
			this.data.length
		) {
			this.formatSettings = [];
			this.formatDates = [];
			this.configFields.map((el) => {
				if (
					["number", "percent", "percentNum", "multiple"].includes(
						el.dataType
					)
				) {
					let format = this.getNumFormat(el);
					const formatData = {
						name: el.colName,
						format: format,
					};
					this.formatSettings.push(formatData);
				}
				if (el.dataType == "datetime" || el.dataType == "date") {
					let format = "";
					if (
						el.format &&
						el.format.length &&
						el.format[0].formatChecked
					) {
						if (el.format[0].dateType == "Quarter") {
							let format_ = el.format[0].selectedFormatDisplay;
							let formatInfo = this.quarterFormat.filter(
								(qur) => qur.value == format_
							);
							if (formatInfo.length) {
								format = formatInfo[0].format;
							} else {
								const formatData = {
									name: el.colName,
									format: format_,
									type: "date",
								};
								this.formatDates.push(formatData);
							}
						} else if (el.format[0].dateType == "Date") {
							let fromIdx =
								el.format[0].selectedFormatDisplay.indexOf("(");
							let toIdx =
								el.format[0].selectedFormatDisplay.indexOf(")");
							let format_ =
								el.format[0].selectedFormatDisplay.slice(
									fromIdx + 1,
									toIdx
								);
							format = this.getDateFormat(format_);
						}
					}
					if (!format) {
						const formatData = {
							name: el.colName,
							format: this.datePipeFormat,
							type: "date",
						};
						this.formatSettings.push(formatData);
					} else {
						const formatData = {
							name: el.colName,
							format: format,
							type: "date",
						};
						this.formatSettings.push(formatData);
					}
				}
			});
			const newTableList = [];
			this.configFields.forEach((item) => {
				if (!item.isHidden) {
					const obj = {
						...item,
						dataType: [
							"MOIC",
							"DPI",
							"TVPI",
							"RVPI",
							"PIC",
							"Multiple",
						].includes(item.colName)
							? "string"
							: item["dataType"],
					};
					if (
						Array.isArray(item.format) &&
						item.format.length > 0 &&
						item.format[0].formatChecked
					) {
						obj.displayName = item.format[0].displayName;
					}
					newTableList.push(obj);
				}
			});
			this.tableList = newTableList;
			const typeMap = {};
			this.tableList.forEach((col) => {
				if (col.dataType === "number") {
					typeMap[col.colName] = true;
				}
			});
			this.data.forEach((_data) => {
				Object.keys(typeMap).forEach((key) => {
					_data[key] =
						_data[key] === null
							? null
							: this.pbf.bankersRounding(Number(_data[key]));
				});
			});
		}
		if (this.config.filterSettings && this.config.filterSettings.length) {
			this.filterSettings.columns = this.config.filterSettings;
		}
		this.ref.markForCheck();
		// this.ref.detectChanges();
	}

	public getFormatOptions(colName) {
		let res =
			this.formatSettings &&
			this.formatSettings.filter((el) => el.name === colName);
		if (res && res.length) return res[0].format;
	}

	private getInfo() {
		this.translation = getTranslation()
		this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
		this.datePipeFormat = localStorage.getItem("datePipe");
	}

	public actionComplete(args) {
		if (args.requestType === "filtering") {
			if (args.action === "filter") {
				let filteredvalues = [];
				for (let item of args.columns) {
					// if (item.type === "datetime" || item.type === "date") {
					// 	item.value = this.pbf.time(item.value);
					// }
					filteredvalues.push({
						field: item.field,
						matchCase: item.matchCase,
						operator: item.operator,
						predicate: item.predicate,
						type: item.type,
						value: item.value,
					});
				}
				this.config.filterSettings = filteredvalues;
			} else {
				this.currentFilterField = "";
				this.config.filterSettings = [];
			}
			const portlet = this.portlet;
			portlet.config = JSON.stringify(this.config);
			const index = this.portlets.findIndex(
				(x) => x.newId === portlet.newId
			);
			if (index > -1) this.portlets[index] = portlet;
			this.currentPage = 1;
			this.reloadTableData({
				page: this.currentPage,
				size: this.pageSize,
				sortedColumn:
					this.sortedColumn === null ? undefined : this.sortedColumn,
				sort: this.sort === null ? undefined : this.sort,
			});
		}
		// 列选择事件
		if (args.requestType === "columnstate") {
			const hideColumns = this.grid.getHiddenColumns();
			this.configFields.map((el) => (el.visible = true));
			if (hideColumns.length > 0) {
				for (let hideitem of hideColumns) {
					if (hideitem.field)
						this.configFields.filter(
							(el) => el.colName === hideitem.field
						)[0].visible = false;
				}
			}
			this.config.fields = JSON.parse(JSON.stringify(this.configFields));
			this.portlet.config = JSON.stringify(this.config);
			const index = this.portlets.findIndex(
				(x) => x.newId === this.portlet.newId
			);
			this.portlets[index].config = JSON.stringify(this.config);
			this.reloadTableData(
				{
					page: this.currentPage,
					size: this.pageSize,
					sortedColumn:
						this.sortedColumn === null
							? undefined
							: this.sortedColumn,
					sort: this.sort === null ? undefined : this.sort,
				},
				true
			);
		}
	}

	public actionBegin(args) {
		if (args.requestType === "filterchoicerequest") {
			const checkboxfilter = this.el.nativeElement.querySelector(
				".e-checkboxfilter"
			) as HTMLElement;
			if (checkboxfilter) {
				if (this.portlet.height == 1) {
					args.filterModel.dlg.style.minHeight = "calc(100% - 12px)";
					args.filterModel.dlg.style.maxHeight = "calc(100% - 12px)";
				} else {
					args.filterModel.dlg.style.minHeight = "350px";
					args.filterModel.dlg.style.maxHeight = "350px";
				}
			}
		}
		if (
			args.requestType == "filterchoicerequest" ||
			args.requestType === "filtersearchbegin"
		) {
			args.filterChoiceCount = 3000;
		}

		// 显示过滤的选项
		if (
			args.requestType === "filterbeforeopen" &&
			this.currentFilterField !== args.columnName
		) {
			args.cancel = true;
			let columnFilter = [];
			let field = args.columnName;
			if (this.config.filterSettings.length) {
				columnFilter = this.config.filterSettings.filter(
					(x) => x.field !== field
				);
			}
			let data = {
				dashboardDataTableId: this.portlet.dashboardDataTableId,
				displayColumnFilter: field,
				columnFilter: columnFilter,
			};
			this.http.post(
				this.api.urlList.GetDistinctColumnValsByPortletDataParam,
				data,
				(res) => {
					this.pageLoading = false;
					let curFomart = this.formatSettings.find(
						(x) => x.name === field
					);
					if (
						curFomart &&
						["date", "datetime"].includes(curFomart.type)
					) {
						res = res[field].map((x) => new Date(x));
					} else {
						res = res[field];
					}
					this.currentFilterField = args.columnName;
					this.filterContents = res;
					this.grid.filterModule.openMenuByField(args.columnName);
					if (columnFilter.length) {
						this.grid.clearFiltering();
					}
				}
			);
			if (
				args.requestType === "filterbeforeopen" &&
				this.currentFilterField === args.columnName
			) {
				let columnName = args.columnName;
				if (this.filterContents) {
					let curResult = this.filterContents;
					let filterOptions = curResult.map((x) => {
						let obj: any = {};
						obj[columnName] = x;
						return obj;
					});
					args.filterModel.options.dataSource = filterOptions;
				}
			}

			// 处理排序
			if (args.requestType === "sorting") {
				if (args.columnName) {
					this.sort = args.direction === "Ascending" ? 1 : 0;
					this.sortedColumn = args.columnName;
					this.reloadTableData({
						page: this.currentPage,
						size: this.pageSize,
						sort: this.sort,
						sortedColumn: this.sortedColumn,
					});
				} else {
					this.sort = null;
					this.sortedColumn = null;
					this.reloadTableData({
						page: this.currentPage,
						size: this.pageSize,
					});
				}

				this.config.tableSortSetting = {
					sort: this.sort,
					sortedColumn: this.sortedColumn,
				};
				this.portlet.config = JSON.stringify(this.config);
				const index = this.portlets.findIndex(
					(x) => x.newId === this.portlet.newId
				);
				this.portlets[index].config = JSON.stringify(this.config);
			}
		}
	}

	public resizeStop(args) {
		let field = this.configFields.filter(
			(el) => el.colName === args.column.field
		);
		if (field && field.length > 0) {
			field[0].width = parseInt(args.column.width);
			const portlet = this.portlet;
			portlet.config = JSON.stringify(this.config);
			const index = this.portlets.findIndex(
				(x) => x.newId === portlet.newId
			);
			this.portlets[index] = portlet;
		}
	}

	public rowDataBound(args) {
		if (args.row.ariaRowIndex % 2 === 0) {
			args.row.style.backgroundColor = "#f8fafb";
		} else {
			args.row.style.backgroundColor = "#ffffff";
		}
	}

	public created(args) {
		if (this.config.showGrandTotals) {
			let el = this.grid.element.querySelector(".e-gridfooter");
			if (el) el.classList.remove("hidesummary");
		} else {
			let el = this.grid.element.querySelector(".e-gridfooter");
			if (el) el.classList.add("hidesummary");
		}
	}

	public exportQueryCellInfo(args: ExcelQueryCellInfoEventArgs): void {
		let curFormat = this.formatSettings.find(
			(x) => x.name === args.column.field
		);
		if (curFormat) {
			if (curFormat.type === "date") {
				args.value = this.pbf.convertDateFormat(
					args.value,
					curFormat.format
						? curFormat.format.replace("dd", "DD")
						: null
				);
			}
		}

		if (
			args.column.field &&
			this.millionFields.includes(args.column.field)
		) {
			args.value = args.data[args.column.field] / 1000000;
		}

		if (this.formatDates && this.formatDates.length) {
			let dateFields = this.formatDates.map((el) => {
				return el.name;
			});

			if (args.column.field && dateFields.includes(args.column.field)) {
				let date = new Date(args.data[args.column.field]);

				let quarter =
					Math.floor((date.getMonth() + 1) % 3) == 0
						? Math.floor((date.getMonth() + 1) / 3)
						: Math.floor((date.getMonth() + 1) / 3) + 1;

				let format;

				this.formatDates.map((el) => {
					if (el.name == args.column.field) format = el.format;
				});
				let year: any;
				switch (format) {
					case "Q1 2021":
						year = date.getFullYear();
						args.value = "Q" + quarter + " " + year;
						break;
					case "Q1 21":
						year = (date as any).getYear() - 100;
						args.value = "Q" + quarter + " " + year;
						break;
					case "2021 Q1":
						year = date.getFullYear();
						args.value = year + " " + "Q" + quarter;
						break;
					case "21 Q1":
						year = (date as any).getYear() - 100;
						args.value = year + " " + "Q" + quarter;
						break;
				}
			}
		}

		// Excel Style Format
		let queryCell =
			this.tableList &&
			this.tableList.filter(
				(item) => item.colName === args.column.field
			)[0];
		if (
			queryCell &&
			queryCell.format &&
			queryCell.format.length &&
			queryCell.format[0].fontSettingChecked
		) {
			if (
				queryCell.format[0].formatChecked &&
				queryCell.format[0].compareSelect
			) {
				let cellData = args.data[args.column.field];
				let condition: Boolean = false;
				switch (queryCell.format[0].compareSelect) {
					case "LessThan":
						condition =
							cellData <
							Number(queryCell.format[0].compareValue1);
						break;
					case "LessThanOrEqualTo":
						condition =
							cellData <=
							Number(queryCell.format[0].compareValue1);
						break;
					case "GreaterThan":
						condition =
							cellData >
							Number(queryCell.format[0].compareValue1);
						break;
					case "GreaterThanOrEqualTo":
						condition =
							cellData >=
							Number(queryCell.format[0].compareValue1);
						break;
					case "Equals":
						condition =
							cellData ===
							Number(queryCell.format[0].compareValue1);
						break;
					case "NotEquals":
						condition =
							cellData !==
							Number(queryCell.format[0].compareValue1);
						break;
					case "Between":
						condition =
							cellData >=
								Number(queryCell.format[0].compareValue1) &&
							cellData <= queryCell.format[0].compareValue2;
						break;
					case "NotBetween":
						condition =
							cellData <
								Number(queryCell.format[0].compareValue1) &&
							cellData >
								Number(queryCell.format[0].compareValue2);
						break;
					default:
						break;
				}
				if (condition) this.cellAddStyleExcel(args, queryCell);
			} else this.cellAddStyleExcel(args, queryCell);
		}
	}

	private cellAddStyleExcel(args, queryCell) {
		if (queryCell.format[0].fontSettingChecked) {
			let formatCellData = args.data[args.column.field];
			if (Math.sign(formatCellData) !== 0)
				if (Math.sign(formatCellData) === -1) {
					args.style = {
						fontColor: this.pbf.rgbaToHex(
							`${queryCell.format[0].negaFontColor}`
						),
						fontSize: Number(
							`${queryCell.format[0].negaFontSizeValue}`.replace(
								"px",
								""
							)
						),
						fontName: `${queryCell.format[0].negaFontFamilyValue}`,
						backColor: this.pbf.rgbaToHex(
							`${queryCell.format[0].negaBackgroundColor}`
						),
					};
				} else {
					args.style = {
						fontColor: this.pbf.rgbaToHex(
							`${queryCell.format[0].fontColor}`
						),
						fontSize: Number(
							`${queryCell.format[0].fontSizeValue}`.replace(
								"px",
								""
							)
						),
						fontName: `${queryCell.format[0].fontFamilyValue}`,
						backColor: this.pbf.rgbaToHex(
							`${queryCell.format[0].backgroundColor}`
						),
					};
				}
		}
	}

	public getLogoInfo(colName, code) {
		if (this.configFields && this.configFields.length) {
			let fields = this.configFields.filter(
				(el) => el.colName == colName
			);
			if (fields && fields.length) {
				return fields[0][code];
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	public getLogoImage(logoDocId) {
		let img;
		if (
			logoDocId !== undefined &&
			logoDocId !== null &&
			logoDocId !== "00000000-0000-0000-0000-000000000000"
		) {
			img =
				this.api.baseurl +
				this.api.urlList.FileGet +
				"?username=" +
				this.userInfo.username +
				"&accountId=" +
				this.userInfo.accountId +
				"&docId=" +
				logoDocId +
				`&Authorization=Bearer`;
		} else {
			img = "../../../../../../assets/img/default_profile_icon.png";
		}
		return img;
	}

	private setQuarterFormat() {
		return [
			{ value: "03/2021", format: "MM/yyyy" },
			{ value: "03/21", format: "MM/dd" },
			{ value: "3/2021", format: "M/yyyy" },
			{ value: "3/21", format: "M/yy" },
			{ value: "March 2021", format: "MMMM yyyy" },
			{ value: "Mar, 2021", format: "MMM, yyyy" },
			{ value: "March, 2021", format: "MMMM, yyyy" },
			{ value: "2021", format: "yyyy" },
		];
	}

	private getDateFormat(format_) {
		switch (format_) {
			case "DD/MM/YYYY":
				return "dd/MM/yyyy";
			case "DD/MM/YY":
				return "dd/MM/yy";
			case "MM/DD/YYYY":
				return "MM/dd/yyyy";
			case "MM/DD/YY":
				return "MM/dd/yy";
			case "YYYY-MM-DD":
				return "yyyy-MM-dd";
			case "YY-MM-DD":
				return "yy-MM-dd";
			case "DD-MM-YYYY":
				return "dd-MM-yyyy";
			case "DD-MM-YY":
				return "dd-MM-yy";
			case "MM-DD-YYYY":
				return "MM-dd-yyyy";
			case "MM-DD-YY":
				return "MM-dd-yy";
			case "MMM DD, YYYY":
				return "MMM dd, yyyy";
			case "DD-MMM-YYYY":
				return "dd-MMM-yyyy";
			default:
				break;
		}
	}

	private getNumFormat(el) {
		//SMP2-3026
		if (
			el.dataType === "number" &&
			el.colName !== "PortInvStk" &&
			el.colName !== "PortFdInvStk"
		) {
			if (el.format && el.format.length && el.format[0].formatChecked) {
				if (
					[10, 11, 12, 13, 14, 15, 16, 17, 18].includes(
						el.format[0].selectedFormat
					)
				)
					this.millionData(el.colName);
				return this.pbf.formatNumber(el.format[0].selectedFormat);
			} else return this.dashboardPorletsService.formatNumber(el.dp);
		}
		if (el.dataType === "percent") {
			if (el.format && el.format.length && el.format[0].formatChecked)
				return this.pbf.formatPercent(el.format[0].selectedFormat);
			else return this.dashboardPorletsService.formatPercent(el.dp);
		}
		if (el.dataType === "percentNum")
			return this.dashboardPorletsService.formatPercentNum(el.dp);
		if (el.dataType === "multiple")
			return this.dashboardPorletsService.formatMultiple(el.dp);
	}

	private millionData(colName) {
		this.millionFields.push(colName);
		if (this.config.filterSettings && this.config.filterSettings.length) {
			let filterFields = this.config.filterSettings.map((el) => {
				return el.field;
			});
			if (filterFields.includes(colName))
				this.config.filterSettings.map((el) => {
					if (el.field == colName) {
						el.value = Number(el.value / 1000000);
					}
				});
		}
	}

	public getAlign(table) {
		if (
			table.format &&
			table.format.length &&
			table.format[0].formatChecked
		)
			return table.format[0].align;
		return ["date", "datetime", "string", "nvarchar", "dropdown"].includes(
			table.dataType
		) &&
			!["MOIC", "DPI", "TVPI", "RVPI", "PIC", "Multiple"].includes(
				table.colName
			)
			? "Left"
			: "Right";
	}

	public pageChanged(args: any) {
		if (args.newProp) {
			// 处理分页器点击事件
			let pageSize = args.newProp.pageSize;
			if (pageSize) {
				this.pageSize = pageSize;
				this.currentPage = 1;
			} else {
				this.currentPage = args.newProp.currentPage;
			}
			this.reloadTableData(
				{
					page: this.currentPage,
					size: this.pageSize,
					sortedColumn:
						this.sortedColumn === null
							? undefined
							: this.sortedColumn,
					sort: this.sort === null ? undefined : this.sort,
				},
				true
			);
		}
	}

	public reloadTableData(setting: any = {}, refreshFormat?) {
		let params: any = {};
		if (setting.page && setting.size) {
			params.currentPage = setting.page;
			params.pageSize = setting.size;
		}
		if (setting.sortedColumn) {
			params.sortedColumn = setting.sortedColumn;
			params.sort = setting.sort;
		}
		this.pageLoading = true;
		this.dashboardPorletsService.getDataByPortletsNew(
			[this.portlet],
			() => {
				this.pageLoading = false;
				const data = DataUtil.parse.parseJson(
					this.dashboardPorletsService.getResultByDataTable(
						this.portlet,
						false,
						false,
						this.dashboard.id
					)
				);

				this.data = data.map((item) => {
					return {
						...item,
						MOIC: `${Number(item["MOIC"]).toFixed(2)}x`,
						DPI: `${Number(item["DPI"]).toFixed(2)}x`,
						TVPI: `${Number(item["TVPI"]).toFixed(2)}x`,
						RVPI: `${Number(item["RVPI"]).toFixed(2)}x`,
						PIC: `${Number(item["PIC"]).toFixed(2)}x`,
						Multiple: `${Number(item["Multiple"]).toFixed(2)}x`,
					};
				});

				// if (this.tableList && this.tableList.length) {
				// 	const typeMap = {};
				// 	this.tableList.forEach((col) => {
				// 		if (col.dataType === "number") {
				// 			typeMap[col.colName] = true;
				// 		}
				// 	});
				// 	this.data.forEach((_data) => {
				// 		Object.keys(typeMap).forEach((key) => {
				// 			_data[key] =
				// 				_data[key] === null
				// 					? null
				// 					: this.pbf.bankersRounding(
				// 							Number(_data[key])
				// 					  );
				// 		});
				// 	});
				// }

				this.totalRecordsCount =
					this.dashboardPorletsService.getResultByDataTable(
						this.portlet,
						true,
						true,
						this.dashboard.id
					);
				this.tableList = [...this.configFields];
				this.tableList = this.tableList.filter((fl) => !fl.isHidden);

				this.tableList = this.tableList.map((item) => {
					return {
						...item,
						dataType: [
							"MOIC",
							"DPI",
							"TVPI",
							"RVPI",
							"PIC",
							"Multiple",
						].includes(item.colName)
							? "string"
							: item["dataType"],
					};
				});
				const typeMap = {};
				this.tableList.forEach((col) => {
					if (col.dataType === "number") {
						typeMap[col.colName] = true;
					}
				});
				this.data.forEach((_data) => {
					Object.keys(typeMap).forEach((key) => {
						_data[key] =
							_data[key] === null
								? null
								: this.pbf.bankersRounding(Number(_data[key]));
					});
				});
				if (this.grid) {
					if (refreshFormat) {
						this.grid.columns.forEach((item) => {
							item.format = this.getFormatOptions(item.field);
						});
						if (this.grid.contentModule) {
							this.grid.refreshColumns();
						}
					} else {
						this.grid.refresh();
					}
				}
				this.ref.markForCheck();
				this.ref.detectChanges();
			},
			params,
			false,
			this.dashboard
		);
	}

	getXTxt(colName, item) {
		if (colName == "MOIC") {
			return `${Number(item["MOIC"]).toFixed(2)}x`;
		} else if (colName == "DPI") {
			return `${Number(item["DPI"]).toFixed(2)}x`;
		} else if (colName == "TVPI") {
			return `${Number(item["TVPI"]).toFixed(2)}x`;
		} else if (colName == "RVPI") {
			return `${Number(item["RVPI"]).toFixed(2)}x`;
		} else if (colName == "PIC") {
			return `${Number(item["PIC"]).toFixed(2)}x`;
		} else if (colName == "Multiple") {
			return `${Number(item["Multiple"]).toFixed(2)}x`;
		}
	}
}
